const ITEMS = [
  "PREMIUM WEB DESIGN",
  "3D EXPERIENCES",
  "ENQUIRY SYSTEMS",
  "CINEMATIC SCROLLING",
  "CONVERSION FOCUSED",
  "GLASSMORPHISM",
  "DON'T COMPETE FOR ATTENTION",
  "COMMAND IT",
];

const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative z-10 overflow-hidden border-y border-white/10 py-6 sm:py-8 select-none">
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className={`font-display text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tight px-8 ${i % 2 ? "text-outline" : "text-white/90"}`}>
                {item}
              </span>
              <span className="h-2 w-2 rounded-full bg-white/30" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
